<div *ngIf="isPageReady" class="flex flex-col" style="width: {{ initParams.width }}; height: {{ initParams.height }}">
  <div class="mb-4">
    <p-button (click)="onAddTemplate()" size="small" label="Add New Template"></p-button>
  </div>
  <div class="grow">
    <div class="w-full" style="height: 100%">
      <prox-ag-grid [gridOptions]="gridOptions" [hasColSizeButtons]="true"></prox-ag-grid>
    </div>
  </div>
  <div class="flex mt-2">
    <div class="mr-2">
      <p-button (click)="onOk()" [disabled]="!selectedEntity" size="small" label="Ok" icon="pi pi-check"></p-button>
    </div>

    <div class="pr-2">
      <p-button (click)="onCancel()" size="small" icon="pi pi-times" label="Cancel"></p-button>
    </div>

    <div *ngIf=" initParams.showClear" class="pl-4">
      <p-button (click)="onClear()" size="small" icon="fa-regular fa-eraser" label="Clear"></p-button>
    </div>

  </div>
</div>
